export const setUserInfo = (user) =>{
    return{
        type: 'SET_USER_INFO',
        user,
    }
}